import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { useFieldValue } from '../hooks/field-value';
import { CanvasFormTabsContext } from '../providers/canvas-form-tabs.provider';
import { FormComponentFactoryContext } from '../providers/context/form-component-factory-context';
import { SchemaContext } from '../providers/SchemaProvider';
import { isDefined } from '../utils';
export const AutoField = ({ propName, required, onRemove }) => {
    var _a;
    const { selectedTab } = useContext(CanvasFormTabsContext);
    const { schema } = useContext(SchemaContext);
    const { value } = useFieldValue(propName);
    const formComponentFactory = useContext(FormComponentFactoryContext);
    if (Object.keys(schema).length === 0) {
        throw new Error(`AutoField: schema is not defined for ${propName}`);
    }
    else if (!isDefined(formComponentFactory)) {
        throw new Error(`AutoField: formComponentFactory is not defined for ${propName}`);
    }
    const isFieldDefined = schema.type === 'object' ? isDefined(value) && Object.keys(value).length > 0 : isDefined(value);
    const isComplexFieldType = schema.type === 'object' || schema.type === 'array' || 'oneOf' in schema || 'anyOf' in schema;
    const isFieldRequired = !isDefined(required) || (isDefined(required) && required);
    const isPropertiesField = schema.type === 'object' && Object.keys((_a = schema === null || schema === void 0 ? void 0 : schema.properties) !== null && _a !== void 0 ? _a : {}).length === 0;
    const shouldLoadField = isFieldRequired || (isDefined(value) && isComplexFieldType && !isPropertiesField);
    if ((selectedTab === 'Required' && !shouldLoadField) || (selectedTab === 'Modified' && !isFieldDefined)) {
        return null;
    }
    const FieldComponent = formComponentFactory(schema);
    return _jsx(FieldComponent, { propName: propName, required: required, onRemove: onRemove });
};
//# sourceMappingURL=AutoField.js.map